/* Etsy Reviews Carousel */
(function () {
  'use strict';

  class KlEtsyReviews extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver(() => this.markReviews());
      this.observer.observe(this, { childList: true, subtree: true });
      this.markReviews();
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    markReviews() {
      // Keep the .reputon-* selectors literal
      this.querySelectorAll('.reputon-single-review .reputon-top-part').forEach((topPart) => {
        if (!topPart.querySelector('.reputon-show-more')) {
          topPart.classList.add('not-read-more-button');
        }
      });
    }
  }

  if (!window.customElements.get('kl-etsy-reviews')) {
    window.customElements.define('kl-etsy-reviews', KlEtsyReviews);
  }
})();
